import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

/**
 * Shows a CTA message on the external share page when a tab's content
 * is not available (costs, info not shared, packing). Prompts the viewer
 * to copy the itinerary to their account (or register if no callback).
 * @param {string} feature - 'costs' | 'info' | 'packing'
 * @param {string} [icon] - Bootstrap icon class (e.g. 'bi-currency-dollar')
 * @param {function} [onCopyItineraryClick] - When provided, shows "Copy Itinerary" and calls this on click
 */
export default function ShareTabFeatureMessage({ feature, icon, onCopyItineraryClick }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const keys = `planDetailShare.registerToUseFeature.${feature}`;
  const titleKey = `${keys}.title`;
  const descKey = `${keys}.description`;
  const defaultIcon = feature === 'costs' ? 'bi-currency-dollar' : feature === 'packing' ? 'bi-suitcase' : 'bi-info-circle';

  const useCopyItinerary = typeof onCopyItineraryClick === 'function';

  return (
    <Card>
      <Card.Body className="text-center py-5">
        <i className={`bi ${icon || defaultIcon} display-1 text-muted mb-3`} aria-hidden />
        <h4 className="text-muted mb-3">{t(titleKey)}</h4>
        <p className="text-muted mb-4">{t(descKey)}</p>
        <Button
          variant="primary"
          onClick={useCopyItinerary ? onCopyItineraryClick : () => navigate('/')}
        >
          {useCopyItinerary ? (
            <>
              <i className="bi bi-clipboard-plus me-2" aria-hidden />
              {t('planDetailShare.copyItinerary.title', { defaultValue: 'Copy Itinerary' })}
            </>
          ) : (
            t('planDetailShare.registerToUseFeature.cta')
          )}
        </Button>
      </Card.Body>
    </Card>
  );
}
